import { useEffect } from "react";
import { hotelData } from "../../config/getHotel";

export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = `${title} | ${hotelData.name}`;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", description);
    }
  }, [title, description]);

  return null;
}